import React, { useRef } from 'react'
import { ContentLoader } from 'foundations-library/components'
import { ContentFactoryInterface } from './ContentLoaderFactory'

interface PropsInterface extends ContentFactoryInterface{
    gap?: number;
    height?: number;
    fillContent?: boolean;
    width?: number | string
}

const rectangles = (n, gap = 10, height = 76, svgH, fillContent, dataTestId) => {
    let times = n
    const els = [<rect x="0" y="0" rx="5" ry="5" width="100%" height={height} key='p-rect-0' data-testid={`${dataTestId}-svg-0`}/>]
    if (fillContent) {
        times = Math.floor(svgH / height) - 2
    }
    for (let i = 1; i < times; i++) {
        els.push(<rect
            y={height * i + gap * i}
            rx="5"
            ry="5"
            width="100%"
            height={height}
            key={`p-rect-${i}`}
            data-testid={`${dataTestId}-svg-${i}`}
        />)
    }

    return els
}

/**
 *
 */
const Rectangle = ({
    times = 1,
    gap = 10,
    height = 50,
    width = 100,
    fillContent = false,
    'data-testid': dataTestId = 'rectangle-content-loader',
    ...props
}: PropsInterface): JSX.Element => {
    const ref = useRef(null)
    const svgHeight = fillContent && ref.current ? (window.innerHeight - ref.current?.offsetTop - 150) : (height * times + gap * times - gap)
    return <div ref={ref} style={props.style} data-testid={dataTestId}>
        <ContentLoader width={width} height={svgHeight} data-testid={`${dataTestId}-svg`}>
            { rectangles(times, gap, height, svgHeight, fillContent, dataTestId) }
        </ContentLoader>
    </div>
}

export default Rectangle
